import React, { useContext } from "react";
import { useNavigate } from 'react-router-dom';
import { AuthContext } from "../../AuthProvider";
import { useLocation } from "react-router-dom";

const HeatingButton = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { esp } = useContext(AuthContext);
    const active = location.pathname === "/heating";

    const handleClick = () => {
        navigate('/heating');
    };

    return (
        <button onClick={handleClick} className={active ? "controlpanel-button controlpanel-button-active" : "controlpanel-button"} disabled={!esp?.heating?.automationStatus}>
            <i className="bi bi-house controlpanel-button-icon" style={{ color: esp?.heating?.automationStatus ? "#FFB405" : "lightgrey", position: 'absolute', top: '-25%' }} />
            <span className="controlpanel-button-number" style={{position: 'absolute', top: '40%' }}>{esp?.sensorData?.indoorTemp?.toFixed(1)}°C</span>
            <span className="controlpanel-button-text" style={{ position: 'absolute', bottom: '10%' }}>Inomhus</span>
        </button>
    );
};

export default HeatingButton;